import { GenericCallCard, GenericEventCard } from './chunk-CNRQOWT5.js';
import { SubCard } from './chunk-2SQIE65B.js';
import { KYBERSWAP_FIELD_LABELS, KYBERSWAP, KYBERSWAP_COMPONENTS, KYBERSWAP_EVENTS, KYBERSWAP_CALLS, KYBERSWAP_KINDS, isRecord, ProtocolValue, humanizeFieldName, FactGrid } from './chunk-GP2K77BU.js';
import { Store } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

var LABELS = {
  source: KYBERSWAP_FIELD_LABELS.source,
  amountInUsd: KYBERSWAP_FIELD_LABELS.amountInUsd,
  amountOutUsd: KYBERSWAP_FIELD_LABELS.amountOutUsd,
  quotedAmountOut: KYBERSWAP_FIELD_LABELS.quotedAmountOut,
  routeId: KYBERSWAP_FIELD_LABELS.routeId
};
function KyberSwapClientData({
  decoded,
  display,
  raw,
  hint
}) {
  const doc = isRecord(decoded) ? decoded : void 0;
  if (!doc) return /* @__PURE__ */ jsx(ProtocolValue, { value: display ?? raw });
  const named = hint?.fields ?? [];
  const keys = [
    ...named.filter((n) => n in doc),
    ...Object.keys(doc).filter((n) => !named.includes(n))
  ];
  const facts = keys.map((name) => ({
    label: LABELS[name] ?? humanizeFieldName(name),
    value: /* @__PURE__ */ jsx(ProtocolValue, { value: doc[name] }),
    when: doc[name]
  }));
  return /* @__PURE__ */ jsx(
    SubCard,
    {
      caption: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5", children: [
        /* @__PURE__ */ jsx(Store, { className: "size-3 shrink-0", "aria-hidden": true }),
        hint?.label ?? "Integrator data"
      ] }),
      meta: /* @__PURE__ */ jsx(
        "span",
        {
          className: "text-2xs uppercase tracking-wide text-muted-foreground",
          title: "Declared by whoever built the route \u2014 carried on-chain, but not enforced by the router.",
          children: "declared"
        }
      ),
      children: /* @__PURE__ */ jsx(FactGrid, { facts })
    }
  );
}

// src/protocols/kyberswap/index.ts
var PID = KYBERSWAP.protocolId;
var C = KYBERSWAP_COMPONENTS;
var value = (kind, component) => ({
  protocolId: PID,
  kind,
  component,
  fields: []
});
var call = (name, component) => ({
  protocolId: PID,
  call: name,
  component,
  summaryFields: []
});
var event = (name, component) => ({
  protocolId: PID,
  event: name,
  component,
  summaryFields: []
});
var KYBERSWAP_HINTS = {
  valueHints: [value(KYBERSWAP_KINDS.clientData, C.clientData)],
  callHints: [call(KYBERSWAP_CALLS.swap, C.swap)],
  eventHints: [
    event(KYBERSWAP_EVENTS.swapped, C.swapped),
    // `Exchange` is emitted by BOTH the router (once per executor call, three
    // fields) and the executor (once per hop, five fields). One card serves
    // both: the generic grid renders whichever fields arrived, which is exactly
    // the honest treatment for two same-named events of different shapes.
    event(KYBERSWAP_EVENTS.exchange, C.exchange),
    event(KYBERSWAP_EVENTS.fee, C.fee),
    event(KYBERSWAP_EVENTS.error, C.error)
  ]
};
function registerKyberSwap(registry) {
  registry.registerValue(C.clientData, KyberSwapClientData);
  registry.registerCall(C.swap, GenericCallCard);
  registry.registerEvent(C.swapped, GenericEventCard);
  registry.registerEvent(C.exchange, GenericEventCard);
  registry.registerEvent(C.fee, GenericEventCard);
  registry.registerEvent(C.error, GenericEventCard);
  registry.registerHints(KYBERSWAP_HINTS);
  return registry;
}

export { KYBERSWAP_HINTS, KyberSwapClientData, registerKyberSwap };
//# sourceMappingURL=chunk-3Q3NEMB3.js.map
//# sourceMappingURL=chunk-3Q3NEMB3.js.map